module.exports = __webpack_public_path__ + "img/destination-puerto-vallarta.6e11ad80.jpg";